const LOCAL_STORAGE_KEY = 'elbridgeSession';

export const useElbridgeSession = (isUserLoggedIn: boolean): boolean => {
    if (!isUserLoggedIn) {
        return false;
    }

    const elbridgeSessionString = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (elbridgeSessionString === 'true') {
        return true;
    }

    return false;
};
